var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle3, _circle4, _path11, _path12, _path13, _path14, _path15, _path16, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReducing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 175 Q68 98 100 85 Q132 98 132 175 Q100 188 68 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 128,
    r: 3,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 128,
    r: 3,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 148 Q100 142 108 148",
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 70 L58 62 M75 60 L70 50 M100 55 L105 45 M125 60 L135 52 M135 75 L145 70",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 95 L45 90 M50 110 L40 108 M55 130 L42 128",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140 100 L150 95 M145 115 L155 112 M140 135 L150 132",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75 50 Q80 45 85 50",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45 Q115 40 120 45",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160 130 L240 130",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232 126 L240 130 L232 134",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268 175 Q268 98 300 85 Q332 98 332 175 Q300 188 268 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 128,
    r: 3,
    fill: "#fafcfb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 128,
    r: 3,
    fill: "#fafcfb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292 148 Q300 155 308 148",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280 70 L280 60 M300 68 L300 58 M320 70 L320 60",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M275 60 Q300 50 325 60",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M260 110 L255 108 M340 110 L345 108",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.25,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170 125 L175 120 M180 132 L184 128 M190 127 L192 122",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210 128 L212 126 M220 130 L222 128 M230 129 L231 127",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 55,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 90,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 60,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 100,
    r: 1.5,
    fill: "#fafcfb",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 220,
    rx: 130,
    ry: 15,
    stroke: "#38bdf8",
    strokeOpacity: 0.12,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducing);
export default __webpack_public_path__ + "static/media/reducing.425438e7952814494befc3f5fb2abbaa.svg";
export { ForwardRef as ReactComponent };